import React, { useState } from 'react';
import LoadingAnimation from "../../common/components/base/LoadingAnimation";
import SimpleDropDown from "../../common/components/base/SimpleDropDown";
import DialogView from "../../common/components/DialogView";
import { Form } from "formik";
import { Builder } from "../../settings/builder";
import { width100 } from "../../settings/otherStyles";
import TextField from "@material-ui/core/TextField";
import Typography from '@material-ui/core/Typography';
import { errorMessage } from "../../settings/otherStyles";
import Button from "@material-ui/core/Button";
import SimpleSelect from "../../common/components/base/SimpleSelect";
import { creativesVar } from "../../settings/cache";
import { useSimulation } from "../../hooks/useSimulation";

const CreativeItem = (props) => {
  const [adsName, setAdsName] = useState('');
  const [landingUrl, setLandingUrl] = useState('');
  const [creative, setCreative] = useState('');
  const [type, setType] = useState('');
  const [validated, setValidated] = useState(false);
  const [open, setOpen] = useState(false);

  const { data, isLoading, error } = useSimulation('cr');

  const handleChangeAdsName = (event) => {
    setAdsName(event.target.value);
  };

  const handleChangeUrl = (event) => {
    setLandingUrl(event.target.value);
  };

  const handleCreative = (event) => {
    setCreative(event.label);
  };

  const handleChangeCreativeType = (event) => {
    setType(event.currentTarget.textContent);
  };

  const handleAdd = () => {
    const item = Builder.createCreative({
      adsName,
      landingUrl,
      creative,
      type
    });
    const results = creativesVar();
    results.push(item);
    creativesVar(results);
    setType('');
    setAdsName('');
    setCreative('');
    setLandingUrl('');
    props.handleAdd();
  };

  const validate = () => {
    setValidated(true);
    return adsName && landingUrl && type && creative;
  };

  const handleClickOpen = () => {
    setOpen(true);
    setValidated(false);
  };

  const handleClose = () => {
    const isValid = validate();
    if (isValid) {
      handleAdd();
      setOpen(false);
    }
  };

  const handleUndo = () => {
    setOpen(false);
  };

  const creatives = data?.creativesSimulation || [];

  return (
    <div>
      <Button className="btn btn-fill btn-info" onClick={handleClickOpen}>Associate ADS</Button>
      <DialogView 
        title="ASSOCIATE ADS" 
        handleUndo={handleUndo} 
        handleClose={handleClose}
        handleSave={handleClose} 
        open={open}
      >
        <Form>
          <div className="row justify-content-center">
            <div className="col-sm-12">
              <div className="form-group bmd-form-group">
                <TextField
                  required
                  label="Ads Name"
                  name="adsName"
                  value={adsName}
                  onChange={handleChangeAdsName}
                  margin="normal"
                  style={width100}
                />
                {(validated && !adsName) ?
                  <Typography style={errorMessage}>Please set a name</Typography> : ""}
              </div>
            </div>
            <div className="col-sm-12">
              <div className="form-group bmd-form-group">
                {isLoading ? (
                  <LoadingAnimation />
                ) : error ? (
                  `Error! ${error.message}`
                ) : (
                  <SimpleSelect
                    onChange={handleCreative}
                    selectedValue={creative}
                    values={creatives.map(value => ({
                      value: value._id,
                      label: value.name
                    }))}
                    placeholder="Creative"
                  />
                )}
                {(validated && !creative) ?
                  <Typography style={errorMessage}>Please set a creative</Typography> : ""}
              </div>
            </div>
            <div className="col-sm-12">
              <div className="form-group bmd-form-group">
                <SimpleDropDown 
                  items={['Active', 'Paused']}
                  caption={type || 'Status'}
                  placeholder="Status"
                  handleChange={handleChangeCreativeType}
                />
                {(validated && !type) ?
                  <Typography style={errorMessage}>Please set a type</Typography> : ""}
              </div>
            </div>
            <div className="col-sm-12">
              <div className="form-group bmd-form-group">
                <TextField
                  required
                  label="Landing Url"
                  name="landingUrl"
                  value={landingUrl}
                  onChange={handleChangeUrl}
                  margin="normal"
                  style={width100}
                />
                {(validated && !landingUrl) ?
                  <Typography style={errorMessage}>Please set an url</Typography> : ""}
              </div>
            </div>
          </div>
        </Form>
      </DialogView>
    </div>
  );
};

export default CreativeItem;
